import React from 'react';
import { styled } from '@mui/material/styles';

import UIKitMenuItem from './MenuItem';
import UIKitRadioButton from './RadioButton';
import { ThemeColor } from '../theme';

interface UIKitMenuItemRadioStyleProps {
  /** ThemeColor del radio (primary, secondary, success, error, warning, tertiary) */
  color?: ThemeColor;
  /** className específico para el radio */
  className?: string;
  /** style específico para el radio */
  style?: React.CSSProperties;
}

interface UIKitMenuItemRadioProps {
  text: string;
  selected: boolean;
  disabled?: boolean;
  name?: string;
  value?: string | number;
  onSelect?: () => void;

  /** Estilos / color específicos del radio embebido */
  radioStyles?: UIKitMenuItemRadioStyleProps;

  /** Estilos del row del menú */
  className?: string;
  style?: React.CSSProperties;
}

// quita padding extra para que el alto del item sea compacto
const StyledRadioButton = styled(UIKitRadioButton)({
  padding: 0,
  '&:hover': {
    backgroundColor: 'transparent', // el hover lo maneja el row
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'transparent',
  },
});

const UIKitMenuItemRadio = React.forwardRef<HTMLLIElement, UIKitMenuItemRadioProps>(
  ({ text, selected, disabled, name, value, onSelect, radioStyles, className, style }, ref) => {
    const handleSelect = () => {
      if (disabled || !onSelect) {
        return;
      }
      onSelect();
    };

    // color del radio
    let radioColor: ThemeColor = 'primary';
    if (radioStyles && radioStyles.color) {
      radioColor = radioStyles.color;
    }

    // style del radio
    let radioStyle: React.CSSProperties | undefined;
    if (radioStyles && radioStyles.style) {
      radioStyle = radioStyles.style;
    }

    return (
      <UIKitMenuItem
        ref={ref}
        text={text}
        disabled={disabled}
        selected={selected} // para que el row pueda estilizarse como “activo”
        onClick={handleSelect}
        className={className}
        style={style}
        leading={
          <StyledRadioButton
            checked={selected}
            color={radioColor}
            name={name}
            value={value}
            tabIndex={-1}
            className={radioStyles && radioStyles.className}
            style={radioStyle}
            onClick={(e) => {
              e.stopPropagation();
              handleSelect();
            }}
          />
        }
      />
    );
  }
);

export default UIKitMenuItemRadio;
